import * as Yup from "yup";
import form from "./form";

const {
  formField: { role }
} = form;

const validations = Yup.object().shape({
  [role.name]: Yup.string().required(role.errorMsg)
});

export default validations;
